<p-dialog appDialogoPadrao="pi pi-pencil" descricao="Nova situação cadastral do prestador." [visible]="visible()" (visibleChange)="visible.set($event)" [style]="{ width: 'min(94vw, 520px)' }" [appendTo]="'body'" header="Alterar situação">
    <form [formGroup]="form" class="flex flex-col gap-4">
        <div>
            <label class="font-semibold block mb-2">Nova situação</label>
            <p-select appendTo="body" formControlName="novaSituacao" [options]="opcoes()" optionLabel="label" optionValue="value" placeholder="Selecione" styleClass="w-full" />
            @if (form.get('novaSituacao')?.touched && form.get('novaSituacao')?.hasError('required')) {
                <small class="text-red-500">Selecione a nova situação.</small>
            }
        </div>

        <div>
            <label class="font-semibold block mb-2">Data da situação</label>
            <p-datepicker formControlName="dtSituacao" dateFormat="dd/mm/yy" [maxDate]="maxDate" [showIcon]="true" [iconDisplay]="'input'" [appendTo]="'body'" styleClass="w-full" class="w-full" />
            @if (form.get('dtSituacao')?.touched && form.get('dtSituacao')?.hasError('required')) {
                <small class="text-red-500">Informe a data da situação.</small>
            }
            @if (form.get('dtSituacao')?.hasError('dataFutura')) {
                <small class="text-red-500">A data não pode ser maior que a data atual.</small>
            }
        </div>

        @if (mostrarGrupos()) {
            <div class="flex flex-col gap-2">
                <label class="font-semibold block">Grupos a reativar</label>
                <div class="flex items-center gap-2"><p-checkbox binary formControlName="comissaoEtica" inputId="grpComissaoEtica" /><label for="grpComissaoEtica">Comissão de Ética</label></div>
                <div class="flex items-center gap-2"><p-checkbox binary formControlName="corpoClinico" inputId="grpCorpoClinico" /><label for="grpCorpoClinico">Corpo Clínico</label></div>
                <div class="flex items-center gap-2"><p-checkbox binary formControlName="diretoria" inputId="grpDiretoria" /><label for="grpDiretoria">Diretoria</label></div>
                <div class="flex items-center gap-2"><p-checkbox binary formControlName="corpoSocietario" inputId="grpCorpoSocietario" /><label for="grpCorpoSocietario">Corpo Societário</label></div>
            </div>
        }
    </form>

    <ng-template #footer>
        <p-button label="Cancelar" severity="secondary" [text]="true" [disabled]="salvando()" (onClick)="fechar()" />
        <p-button label="Confirmar" icon="pi pi-check" [loading]="salvando()" [disabled]="form.invalid" (onClick)="salvar()" />
    </ng-template>
</p-dialog>

<p-confirmDialog [key]="confirmKey" [appendTo]="'body'" />
